import { useTranslation } from "react-i18next";
import { Archive } from "lucide-react";
import { Badge } from "../../../components/ui/badge";
import { formatDate } from "../../../lib/format";

/**
 * GR-004 archive marker: the incident was closed three years ago and has left
 * the working set. Icon plus text, never colour alone; the date sits in the
 * title. The handle comes from the call site, where the literal lives.
 */
export function ArchivedBadge({ archivedAt, testid }: { archivedAt: string; testid: string }): JSX.Element {
  const { t } = useTranslation();
  return (
    <Badge
      variant="outline"
      data-testid={testid}
      title={t("archive.badgeTitle", { date: formatDate(archivedAt) })}
      className="border-stone-300 bg-stone-100 text-stone-800 dark:border-stone-700 dark:bg-stone-900/40 dark:text-stone-200"
    >
      <Archive className="mr-1 h-3 w-3" aria-hidden="true" />
      {t("archive.badge")}
    </Badge>
  );
}
